module.exports = __webpack_public_path__ + "static/media/pharma1.6394c302.png";